import React from "react"
import { Card, CardBody, Badge } from "reactstrap"
import { toast } from "react-toastify"
import SectionHeader from "components/Common/SectionHeader"
import ThemePlaceholder from "components/Common/ThemePlaceholder"
import { CopyButton } from "components/Common/CopyButton"

// Helper function to check if value exists
const hasValue = (value) => {
  if (value === null || value === undefined) return false
  if (typeof value === "string" && value.trim() === "") return false
  if (Array.isArray(value) && value.length === 0) return false
  return true
}

const LinkWithCopy = ({ label, value }) => (
  <div className="d-flex align-items-center justify-content-end gap-2">
    <a
      href={value}
      target="_blank"
      rel="noopener noreferrer"
      className="btn btn-sm btn-soft-primary py-0 px-2"
      title={`View ${label}`}
    >
      <i className="bx bx-link-external me-1"></i>
      View
    </a>
    <CopyButton
      text={value}
      variant="outline-secondary"
      className="py-0 px-1"
      title={`Copy ${label}`}
      successTitle={`${label} copied`}
      toastCallback={(type) => {
        if (type === "success") {
          toast.success(`${label} copied to clipboard.`)
        } else {
          toast.error(`Failed to copy ${label.toLowerCase()}.`)
        }
      }}
    />
  </div>
)

const InfoItem = ({ label, value, loading }) => {
  if (loading) {
    return (
      <div className="d-flex justify-content-between py-2 border-bottom">
        <span className="text-muted">{label}:</span>
        <ThemePlaceholder style={{ width: 150, height: 20, borderRadius: 4 }} />
      </div>
    )
  }

  let displayValue = value
  if (!hasValue(value)) {
    displayValue = <Badge color="light" className="text-muted">Not Provided</Badge>
  } else if (label === "Email" && typeof value === "string") {
    displayValue = (
      <a href={`mailto:${value}`} className="text-primary">
        {value}
      </a>
    )
  } else if (
    (label === "Website" || label === "Stock Link") &&
    typeof value === "string"
  ) {
    displayValue = <LinkWithCopy label={label} value={value} />
  } else if (label === "Mobile Numbers" && Array.isArray(value)) {
    displayValue = (
      <div className="d-flex flex-column gap-1">
        {value.map((mobile, index) => (
          hasValue(mobile) && (
            <Badge key={index} color="primary" className="d-inline-flex align-items-center">
              <i className="bx bx-phone me-1" style={{ fontSize: "12px" }}></i>
              {mobile}
            </Badge>
          )
        ))}
      </div>
    )
  } else if (label === "Slug") {
    displayValue = <Badge color="info">{value}</Badge>
  }

  return (
    <div className="d-flex justify-content-between py-2 border-bottom">
      <span className="text-muted">{label}:</span>
      <span className="fw-medium text-end">{displayValue}</span>
    </div>
  )
}

const ImporterInfoCard = ({ importer, loading, action = null }) => {
  const infoItems = [
    { label: "Name", value: importer && importer.name },
    { label: "Slug", value: importer && importer.slug },
    { label: "Email", value: importer && importer.email },
    { label: "Website", value: importer && importer.website },
    { label: "Stock Link", value: importer && importer.stock_link },
    { label: "Mobile Numbers", value: importer && importer.mobile },
  ]

  return (
    <Card className="border-0 shadow-sm mb-4">
      <CardBody className="p-3">
        <SectionHeader
          icon="bx bx-info-circle"
          title="General Information"
          action={action}
        />
        <div className="specs-list">
          {infoItems.map((item, index) => (
            <InfoItem
              key={index}
              label={item.label}
              value={item.value}
              loading={loading}
            />
          ))}
        </div>
      </CardBody>
    </Card>
  )
}

export default ImporterInfoCard
